
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Expand = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <polygon points="12.5 16.6 6 10 7 9 12.5 14.4 18 9 19 10 12.5 16.6"></polygon>
        </g>
      </g>
    </IconBase>);
};

Expand.defaultProps = {
  title: 'Expand',
};

export default Expand;
